module.exports = __webpack_public_path__ + "img/21.f92a2e37.jpg";